import IArticleCampaigns from "../../types/IArticleCampaigns";
import IArticleCampaignsV2 from "../../types/IArticleCampaignsV2";
import ICategoryCampaigns from "../../types/ICategoryCampaigns";
import ICategoryCampaignsV2 from "../../types/ICategoryCampaignsV2";
import IMerchandisingSlots from "../../types/IMerchandisingSlots";
import CampaignInfoStorageContainer from "./localStorage";

// Class to work with localStorage as a campaing UUID container
export default class CampaignInfoNoStorageContainer extends CampaignInfoStorageContainer {
  public storeCategories(campaignId: string, campaignInfo: ICategoryCampaigns | ICategoryCampaignsV2): boolean {
    return false;
  }

  public storeArticles(
    campaignId: string,
    category: string,
    campaignInfo: IArticleCampaigns | IArticleCampaignsV2
  ): boolean {
    return false;
  }

  public storeSlots(campaignId: string, info: IMerchandisingSlots): boolean {
    return false;
  }

  public getSlots(campaignId: string): IMerchandisingSlots {
    return {};
  }

  public getCategories(campaignId: string): ICategoryCampaigns | ICategoryCampaignsV2 {
    return {};
  }

  public getArticles(campaignId: string, category: string): IArticleCampaigns | IArticleCampaignsV2 {
    return {};
  }

  // clear all campaign info from localStorage
  public empty(campaignId: string): boolean {
    return false;
  }
}
